import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';

import {TestOrderTableColumnDef, TestOrderTableV0ColumnSystemNames} from './DataMappingTypes';
import {ColumnMappingConfig} from './validateDataMapping';

export enum SaveToResultsTarget {
  TEST_ORDER_TABLE = 'TEST_ORDER_TABLE',
}

// Keep in sync with SaveToResultsTargetColumnDisplayName defined in
// benchling/pipelines/step_type_library/step_config_shape_declarations/save_to_results_step_config_shapes
export enum SaveToResultsTargetColumnDisplayName {
  TEST_ORDER_ID = 'Test Order ID',
  FINAL_TEST_ORDER_STATUS = 'Final Test Order Status',
  NEXT_DILUTION_FACTOR = 'Next Dilution Factor',
  SHOULD_RETEST = 'Should Retest',
  ANALYSIS_COMMENT = 'Analysis Comment',
}

export const REQUIRED_COLUMN_DEFS_BY_TARGET: Record<SaveToResultsTarget, Array<TestOrderTableColumnDef>> = {
  [SaveToResultsTarget.TEST_ORDER_TABLE]: [
    {
      displayName: SaveToResultsTargetColumnDisplayName.TEST_ORDER_ID,
      systemName: 'test_order_id',
      type: {
        leafType: LeafType.TEXT,
      },
    },
    {
      displayName: SaveToResultsTargetColumnDisplayName.FINAL_TEST_ORDER_STATUS,
      systemName: 'final_test_order_status',
      type: {
        leafType: LeafType.TEXT,
      },
    },
    {
      displayName: SaveToResultsTargetColumnDisplayName.NEXT_DILUTION_FACTOR,
      systemName: 'next_dilution_factor',
      type: {
        leafType: LeafType.INTEGER,
        isNullable: true,
      },
    },
    {
      displayName: SaveToResultsTargetColumnDisplayName.SHOULD_RETEST,
      systemName: 'should_retest',
      type: {
        leafType: LeafType.BOOLEAN,
      },
    },
    {
      displayName: SaveToResultsTargetColumnDisplayName.ANALYSIS_COMMENT,
      systemName: 'analysis_comment',
      type: {
        leafType: LeafType.TEXT,
        isNullable: true,
      },
    },
  ],
};

export const COLUMN_MAPPING_CONFIG_BY_TARGET: Record<
  SaveToResultsTarget,
  Partial<Record<TestOrderTableV0ColumnSystemNames, ColumnMappingConfig>>
> = {
  [SaveToResultsTarget.TEST_ORDER_TABLE]: {
    analysis_comment: {
      isRequired: false,
    },
  },
};
